import { IPromise, IScope } from 'angular'
import {
  ApiRegister,
  ApiRetailerPaymentType,
  ApiTransaction,
} from '@vend/types'
import { $q } from '../../../ng-compat/imports'
import { LSPAYModalOptions } from './helpers/lspay.types'

/**
 * Controller class for the LSPAY
 *
 * @class LSPAYModalController
 */
export class LSPAYModalController {
  public readonly close: () => void
  public readonly amount: number
  public readonly outletId: string
  public readonly currency: string
  public readonly register: ApiRegister
  public readonly registerSaleId: string
  public readonly paymentIntentId?: string
  public readonly isRecovery?: boolean
  public readonly withSurcharge?: boolean
  public readonly tipEligibleAmount?: number
  public readonly originalRegisterSalePaymentIds?: string[]
  public readonly originalSalePaidByOtherPT?: boolean
  public readonly retailerPaymentType: ApiRetailerPaymentType
  public readonly transactionId: string
  private readonly internalClose: (val: IPromise<ApiTransaction>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<ApiTransaction>) => void,
    public readonly options: LSPAYModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.internalClose = close
    this.close = () => this.internalClose($q.reject())
    this.amount = options.amount
    this.outletId = options.outletId
    this.currency = options.currency
    this.register = options.register
    this.registerSaleId = options.registerSaleId
    this.originalRegisterSalePaymentIds = options.originalRegisterSalePaymentIds
    this.originalSalePaidByOtherPT = options.originalSalePaidByOtherPT
    this.retailerPaymentType = options.retailerPaymentType
    this.transactionId = options.transactionId
    this.paymentIntentId = options.paymentIntentId
    this.isRecovery = options.isRecovery
    this.withSurcharge = options.withSurcharge
    this.tipEligibleAmount = options.tipEligibleAmount

    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
